"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-twelve/sections/serviceSlider.tsx */

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
import "swiper/css";
import { FC, ComponentProps } from "react";

type HomeTwelveServiceSliderRowOneItem = {
    /** Detected variants: "Oxygen therapy" | "ECG & diagnostic coordination" | "Antibiotic therapy support" | "Medication administration" | "IV fluids & injections" */
    text: string;
};

type HomeTwelveServiceSliderRowTwoItem = {
    /** Detected variants: "Recovery after surgery" | "Physiotherapy coordination" | "Monitoring during bed rest" | "Stroke rehabilitation support" */
    text: string;
};
export type HomeTwelveServiceSliderGeneratedProps = {
    rowOne?: HomeTwelveServiceSliderRowOneItem[];
    rowTwo?: HomeTwelveServiceSliderRowTwoItem[];
    sectionSwiper0SwiperProps?: Partial<ComponentProps<typeof Swiper>>;
    sectionSwiper1SwiperProps?: Partial<ComponentProps<typeof Swiper>>;
};

const HomeTwelveServiceSliderGenerated: FC<HomeTwelveServiceSliderGeneratedProps> = ({
    rowOne = [],
    rowTwo = [],
    sectionSwiper0SwiperProps,
    sectionSwiper1SwiperProps,
}) => {
    return (
        <section className="slider-section slider-section-twelve">
            <Swiper modules={[Autoplay, FreeMode]} freeMode={true} loop={true} slidesPerView={"auto"} speed={10000} allowTouchMove={false} autoplay={{
                delay: 0,
                disableOnInteraction: false,
            }} className="horizontal-slide slide-one slide-twelve bg-primary d-flex" {...(sectionSwiper0SwiperProps ?? {})}>
                {rowOne.map((text, index) => (
                    <SwiperSlide key={index} style={{ width: "auto" }}>
                        <div className="services-slide">
                            <h3>{text.text}</h3>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <Swiper modules={[Autoplay, FreeMode]} freeMode={true} loop={true} slidesPerView={"auto"} speed={10000} allowTouchMove={false} autoplay={{
                delay: 0,
                reverseDirection: true,
                disableOnInteraction: false,
            }} className="horizontal-slide slide-two slide-twelve two d-flex" {...(sectionSwiper1SwiperProps ?? {})}>
                {rowTwo.map((text, index) => (
                    <SwiperSlide key={index} style={{ width: "auto" }}>
                        <div className="services-slide">
                            <h3>{text.text}</h3>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
};

export default HomeTwelveServiceSliderGenerated;
